import { PUBLIC_ROOT } from 'portal-modules/common/constants/urls'
import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const CHANGE_ACCOUNT = {
  ROOT: `${PRIVATE_ROOT}/change-account`,
  PROPERTY: `${PRIVATE_ROOT}/change-account/property`,
  UNIT: `${PRIVATE_ROOT}/change-account/unit`,
  OPTION: `${PRIVATE_ROOT}/change-account/option`,
}

export const AUTH = {
  SIGNUP: `${PUBLIC_ROOT}/signup`,
  SIGNUP_PROPERTY_SELECTION: `${PUBLIC_ROOT}/signup-property`,
  SIGNUP_VERIFICATION: `${PUBLIC_ROOT}/signup-verification`,
  SELECT_PROPERTY: `${PUBLIC_ROOT}/select-property`,
  SELECT_LEASE: `${PUBLIC_ROOT}/select-lease`,
  RESET_PASSWORD: `${PUBLIC_ROOT}/reset-password`,
  RESET_CODE: `${PUBLIC_ROOT}/reset-password/code`,
  NEW_PASSWORD: `${PUBLIC_ROOT}/reset-password/new-password`,
  PASSWORD_RESET_SUCCESS: `${PUBLIC_ROOT}/reset-password/success`,
  LANGUAGE_SELECTION: `${PUBLIC_ROOT}/select-language`,
  SELECT_CONTRACT: `${PRIVATE_ROOT}/select-contract`,
  MAINTENANCE_SURVEY: `${PUBLIC_ROOT}/maintenance-survey`,
  MAINTENANCE_SURVEY_SUCCESS: `${PUBLIC_ROOT}/maintenance-survey-success`,
  RENEWAL_SIGNAL: `${PUBLIC_ROOT}/renewal-signal`,
  CREATE_PASSWORD: `${PUBLIC_ROOT}/create-password`,
  INVALID_TOKEN: `${PUBLIC_ROOT}/invalid-token`,
  USED_TOKEN: `${PUBLIC_ROOT}/used-token`,
  CHOOSE_OPTION: `${PUBLIC_ROOT}/choose-option`,
}
